// The optional ?project=<projectId> scope param the client SPA's debug "Open
// talent platform" button appends when it deep-links here. It rides on
// location.search (App.tsx preserves search on every push/replace, exactly like
// ?debug=1), so it needs NO route-url change and keeps pathToRoute/routeToPath
// inverse. "" / whitespace → no filter (the full directory).

/** The project id the directory is scoped to, or null for the full directory. */
export function projectFilterFromSearch(search: string): string | null {
  const raw = new URLSearchParams(search).get("project");
  const id = raw?.trim();
  return id ? id : null;
}

/** Drop ?project= from the current URL, keeping the path and adding no history
 *  entry — the "Show all projects" escape hatch. Guarded for node (vitest). */
export function clearProjectFilterInUrl(): void {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  url.searchParams.delete("project");
  window.history.replaceState({}, "", url.pathname + url.search);
}
